import { map, sum, sumBy } from "lodash";
import { useMemo } from "react";
import { useFormContext } from "react-hook-form";
import {
	flatPromotionType,
	percentPromotionType,
} from "@/constants/promotion-types";
import type { CheckoutSchemaType } from "@/routes/checkout/schema";

export const useCheckoutAmounts = () => {
	const { watch } = useFormContext<CheckoutSchemaType>();
	const totalProducts = watch("saleProductsAttributes");
	const promotion = watch("salePromotionAttributes");

	const totalProductsAmountCents = sum(
		map(totalProducts, (product) => product.quantity * product.amountCents),
	);
	const itemsCount = sumBy(totalProducts, "quantity");
	const totalAmountCents = useMemo(() => {
		switch (promotion?.type) {
			case flatPromotionType.key:
				return flatPromotionType.calculatePrice(
					totalProductsAmountCents,
					promotion.amountCents,
				);
			case percentPromotionType.key:
				return percentPromotionType.calculatePrice(
					totalProductsAmountCents,
					promotion.amountCents,
				);
			default:
				return totalProductsAmountCents;
		}
	}, [totalProductsAmountCents, promotion?.amountCents, promotion?.type]);

	return {
		itemsCount,
		totalAmountCents,
		totalProductsAmountCents,
	};
};
